module.exports = __webpack_public_path__ + "img/trash-light.f5a99b6a.png";